<template>
  <v-app-bar app color="rgba(20, 35, 45)" dark>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon
          v-bind="attrs"
          v-on="on"
          @click.stop="menu = !menu"
        ></v-app-bar-nav-icon>
      </template>
      <span>Menú</span>
    </v-tooltip>

    <v-navigation-drawer
      v-model="menu"
      height="505px"
      width="280px"
      app
      absolute
      temporary
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="../../../public/AvatarDr.png" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ usuario }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-group
          no-action
          prepend-icon="mdi-calendar-clock"
          v-if="!$store.state.ocultarTurnos"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Turnos</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="$vuetify.breakpoint.width > 800"
            @click="verTurnos(0)"
            link
          >
            <v-list-item-title>Nuevo Turno</v-list-item-title>
          </v-list-item>

          <v-list-item v-else @click="verTurnos(1)" link>
            <v-list-item-title>Nuevo Turno</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-for="(turno, i) in turnos"
            :key="i"
            link
            @click="verTurnos(2)"
          >
            <v-list-item-title v-text="turno[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>

        <v-list-group
          no-action
          prepend-icon="mdi-key-variant"
          v-if="$store.state.idInstitucion"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Competiciones</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(conf, i) in competiciones"
            :key="i"
            :to="conf[1]"
            link
          >
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>

        <v-list-group no-action prepend-icon="mdi-key-variant">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cuenta</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(conf, i) in confs" :key="i" :to="conf[1]" link>
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout()" block>
            <v-icon left>mdi-power-standby</v-icon>
            Cerrar Sesión</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
    <v-divider vertical></v-divider>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3" icon small v-bind="attrs" v-on="on" to="/Home">
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </template>
      <span>Página de Inicio</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          icon
          x-small
          v-bind="attrs"
          v-on="on"
          @click="cambiarContrasena"
        >
          <v-icon>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <span>Cambiar Contraseña</span>
    </v-tooltip>
    <v-tooltip top v-if="$store.state.idInstitucion">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          icon
          small
          v-bind="attrs"
          v-on="on"
          @click="verInfoInstitucion"
        >
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span>Información del Complejo</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-2" v-bind="attrs" v-on="on" icon small @click="logout">
          <v-icon>mdi-power-standby</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <h2 v-if="!isMobile() && this.$store.state.nombreInstitucion">
      {{ this.$store.state.nombreInstitucion }}
    </h2>
    <v-spacer></v-spacer>
    <span class="app-version">v.{{ $appVersion }}</span>
    <!-- <v-toolbar-title>GesMed</v-toolbar-title> -->
    <router-link to="/Home">
      <span class="mi-cancha">Tokia Play</span>
    </router-link>

    <CambiarContrasena
      :visible="showCambiarContrasena"
      :usu="usuario"
      @close="showCambiarContrasena = false"
    >
    </CambiarContrasena>

    <InfoInstitucion
      :visible="showInfoInstitucion"
      :idInstitucion="$store.state.idInstitucion"
      @close="showInfoInstitucion = false"
    >
    </InfoInstitucion>
  </v-app-bar>
</template>

<script>
import router from "@/router";
import CambiarContrasena from "../Cuenta/CambiarContrasena.vue";
import InfoInstitucion from "../Turnos/InfoInstitucion.vue";
export default {
  data() {
    return {
      showCambiarContrasena: false,
      showInfoInstitucion: false,
      menu: false,
      turnos: [["Mis Turnos", "/MisTurnos"]],

      competiciones: [
        ["Ver Competiciones", "/Competiciones"],
        ["Ranking Jugadores", "/Rankings"],
      ],

      confs: [["Modificar Datos", "/ConfCuenta"]],
      group: null,
      usuario: null,
    };
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    isMobile() {
      if (window.innerWidth < 992) {
        return true;
      } else {
        return false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    cambiarContrasena() {
      this.showCambiarContrasena = true;
    },
    verInfoInstitucion() {
      this.showInfoInstitucion = true;
    },
    verTurnos(i) {
      if (i == 0) {
        this.$store.dispatch("setVista", 0);
        router.push("/BuscarInstitucion");
      } else {
        if (i == 1) {
          this.$store.dispatch("setVista", 1);
          router.push("/BuscarInstitucion");
        } else {
          router.push("/MisTurnos");
        }
      }
    },
  },
  created() {
    this.usuario = this.$store.state.nombreUsuarioPaciente.toString().trim();
  },
  components: {
    CambiarContrasena,
    InfoInstitucion,
  },
};
</script>
<style scoped>
.app-version {
  color: white;
  font-size: 0.75rem;
  margin-right: 1.5rem;
}
.mi-cancha {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
}
</style>
